export default __webpack_public_path__ + "static/media/i6.05506917.jpeg";